<template>
  <div class="animated fadeIn">
    <b-alert :show="dismissCountDown"
       dismissible
       variant="success"
       @dismissed="dismissCountDown = 0"
       @dismiss-count-down="countDownChanged">
      <p>Acompanhante atualizado com sucesso!</p>
      <b-progress variant="success"
        :max="10"
        :value="dismissCountDown"
        height="4px">
      </b-progress>
    </b-alert>
    <b-row>
      <b-col lg="12">
        <c-table striped
          caption="<i class='fa fa-users'></i> Lista de Acompanhantes <button class='btn btn-default btn-sm pull-right btn-participant'><i class='fa fa-arrow-left'></i>&nbsp; Voltar para o Participante</button>"
          :items="items"
          :fields="fields"
          :excelFields="excelFields"
          :excelData="excelData"
          excelName="Acompanhantes">
        </c-table>
      </b-col>
    </b-row>
  </div>

</template>

<script>
  import cTable from '../../components/Table.vue';

  export default {
    name: 'tables',
    components: {cTable},
    props: {
      participantId: false
    },
    data () {
      return {
        items: [],
        fields: [
          {key: 'passportFirstName', label: 'Nome', sortable: true},
          {key: 'selected', label: 'Acompanhante', sortable: true},
          {key: 'ptcCount', label: `Qtd de PTC's`, sortable: true},
          {key: 'type', label: 'Parentesco', sortable: true},
          {key: 'formattedPassport', label: 'Possui passaporte?', sortable: true},
          {key: 'flightLabel', label: 'Voo', sortable: true},
          {key: 'actions', label: 'Ações'}
        ],
        excelFields: {
          'Nome': 'passportFirstName',
          'Acompanhante': 'selected',
          'Qtd de PTCs': 'ptcCount',
          'Parentesco': 'type',
          'Possui passaporte?': 'formattedPassport'
        },
        excelData: [],
        loading: false,
        updatedGuest: false,
        dismissCountDown: 0
      }
    },
    mounted () {
      const btn = document.querySelector('.btn-participant')
      btn.addEventListener('click', () => {
        this.$parent.showGuests = false
      })
      if (this.$parent.updatedGuest === true) {
        this.dismissCountDown = 10
      }
      if (this.$parent.participant.guests !== undefined) {
        this.items = this.$parent.participant.guests.map(guest => {
          guest.formattedPassport = guest.hasPassport === 1 ? 'Não' : 'Sim'
          guest.selected = guest.flight !== null ? 'Qualificado' : guest.extra? 'Extra': 'Não'
          guest.flightLabel = guest.flight !== null ? 'Grupo ' + guest.flight.flight.group_number : '---'
          guest.actions = {
            show: true,
            id: guest.id,
            edit: 'guest',
            modal: true,
            modalTitle: 'Dados do acompanhante',
            route: 'Acompanhante'
          }
          return guest
        })
        this.excelData = this.items
      }
    },
    methods: {
      countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/guests/List.vue